<template>
  <v-app>
    <v-app-bar app color="primary" dark v-if="!hideAppBar">
      <div class="d-flex align-center">
        <v-btn v-if="!$route.meta.hideBackButton" class="accent" rounded @click="$router.goBack()">
          <v-icon small>mdi-arrow-left</v-icon>
        </v-btn>

        <v-btn text disabled>
          <span class="mr-2 white--text">{{ getCurrentPage }}</span>
        </v-btn>
      </div>

      <v-spacer></v-spacer>
      <v-img alt="Rock Bingo Logo" class="shrink mr-2" contain src="@/assets/BM_Logo_Full_Size.png"
        transition="scale-transition" width="140" />
      v1.1.0
    </v-app-bar>

    <v-main>
      <router-view></router-view>
    </v-main>
    <span v-for="(snackbar, i) in getSnackbarQueue" :key="i">
      <snackbar :value="snackbar"></snackbar>
    </span>
    <bm-dialog :value="getDialogQueue" v-if="getDialogQueue"></bm-dialog>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import Snackbar from "@/plugins/notifications/Snackbar";
import BmDialog from "@/plugins/notifications/Dialog";

export default {
  name: "App",
  computed: {
    ...mapGetters(["getSnackbarQueue", "getDialogQueue", "getCurrentPage"]),
    hideAppBar() {
      return this.$router.currentRoute.meta.hideAppBar === true;
    },
  },
  components: {
    Snackbar,
    BmDialog,
  },
};
</script>

<style>
.primary.main_button.v-btn {
  border-color: #9ac4f8 !important;
  border-style: double;
}
</style>

<style lang="scss">
html {
  overflow-y: auto;
}

.card {
  background-color: #2f3693 !important;
  border: 4px solid #fcbf49 !important;
  border-radius: 24px !important;
  position: relative;
  z-index: 1;

  &:before {
    position: absolute;
    content: "";
    background-image: url("../src/assets/session-left-bg.png");
    background-repeat: no-repeat;
    background-position: left;
    background-size: contain;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    z-index: -1;
  }

  &:after {
    position: absolute;
    content: "";
    background-image: url("../src/assets/session-top-bg.png");
    background-repeat: no-repeat;
    background-position: top;
    background-size: contain;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    z-index: -1;
  }
}

.card-disabled {
  background-color: #E3E3E3 !important;
  border: 4px solid #D9D9D9 !important;
  border-radius: 24px !important;
  position: relative;
  z-index: 1;
  color: #AEAEAE !important;

  &:before {
    position: absolute;
    content: "";
    background-image: url("../src/assets/session-left-bg.png");
    background-repeat: no-repeat;
    background-position: left;
    background-size: contain;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    z-index: -1;
  }

  &:after {
    position: absolute;
    content: "";
    background-image: url("../src/assets/session-top-bg.png");
    background-repeat: no-repeat;
    background-position: top;
    background-size: contain;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    z-index: -1;
  }

  .disableText {
    color: #AEAEAE !important;
    pointer-events: none;
    cursor: not-allowed;
    opacity: 0.6;
  }
}
</style>